var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDecoDsuMeniu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 233.814,
    height: 277.725,
    viewBox: "0 0 233.814 277.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9656",
    "data-name": "Group 9656",
    transform: "translate(0 277.725) rotate(-90)",
    opacity: 0.239
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22099",
    "data-name": "Path 22099",
    d: "M237.44,193.223a141.527,141.527,0,0,1-123.2,38.54,144.054,144.054,0,0,1-53.7-22.113A139,139,0,0,1,31.469,6.841a12.636,12.636,0,1,1,18.954,15.8A114.357,114.357,0,0,0,167.941,204.6a96.038,96.038,0,0,0,26.536-10.109,114.987,114.987,0,0,0,32.854-171.85,12,12,0,0,1,.632-17.059h0a12.636,12.636,0,0,1,18.323,1.264,139.627,139.627,0,0,1-8.845,186.382Z",
    transform: "translate(0 0)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22100",
    "data-name": "Path 22100",
    d: "M37.909,75.816A37.908,37.908,0,1,1,75.817,37.908,37.909,37.909,0,0,1,37.909,75.816Z",
    transform: "translate(100.954 57.966)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22101",
    "data-name": "Path 22101",
    d: "M148.349,122.565A88.453,88.453,0,0,1,16.3,6.314a12.636,12.636,0,0,1,18.954-1.9h.632a12.636,12.636,0,0,1,1.264,15.8,63.18,63.18,0,0,0,7.582,82.766,64.446,64.446,0,0,0,87.19,0A63.18,63.18,0,0,0,139.5,20.213a13.268,13.268,0,0,1,1.9-16.427,12,12,0,0,1,18.954,1.9A88.451,88.451,0,0,1,148.349,122.565Z",
    transform: "translate(48.331 37.483)",
    fill: "#f5f5f5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoDsuMeniu);
export default __webpack_public_path__ + "static/media/DecoDSUMeniu.29625fd846a75b0d3a165c1ddce1a1d8.svg";
export { ForwardRef as ReactComponent };